<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col>
        <h3>Grundinställningar</h3>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card>
          <b-card-header>
            {{ info.name }}
          </b-card-header>
          <b-card-body>
            <b-row>
              <b-col>
                <label>Beskrivning:</label><br />
                {{ info.description }}
                <br />
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <div v-if="info.active">
                  <b-icon-check-circle-fill></b-icon-check-circle-fill> Aktiv
                </div>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <hr />
    <b-row>
      <b-col>
        <h3>Kopplingar</h3>
      </b-col>
    </b-row>
    <b-row v-for="(cn, i) in info.connectors" :key="i">
      <b-col>
        <b-card>
          <b-card-header>{{ cn.name }}</b-card-header>
          <b-card-body>
            <b-row>
              <b-col>
                <label>Typ:</label><br />
                {{ cn.connectortype }}
              </b-col>
              <b-col
                ><b-button @click="ShowSettings(cn)"
                  >Inställningar</b-button
                ></b-col
              >
            </b-row>

            <br />
            <b-row>
              <b-col>
                <label>Systemtyp:</label><br />
                {{ cn.provider }}
                <br />
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <label>Beskrivning:</label><br />
                {{ cn.description }}
                <br />
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
      v-if="currentConnectorEdit"
      title="Kopplingsinställningar"
      v-model="showConnectorSettings"
      size="xl"
      ok-only
      @ok="GetData()"
    >
      <ilogsettings
        v-if="SelectConnector('iLog', 'Plan')"
        v-bind:connector="currentConnectorEdit"
      ></ilogsettings>
      <fortnoxsettings
        v-if="SelectConnector('Fortnox', 'Erp')"
      ></fortnoxsettings>
    </b-modal>
  </div>
</template>

<script>
import ilogsettings from "../tenant/ilogsettings";
import fortnoxsettings from "../tenant/fortnoxsettings";
import Ilogsettings from "./ilogsettings.vue";
import Fortnoxsettings from "./fortnoxsettings.vue";

import { Api } from "../../lib/api";
const api = new Api();

export default {
  name: "tentantinfo",
  components: { ilogsettings, fortnoxsettings },
  data() {
    return {
      info: null,
      showConnectorSettings: false,
      currentConnectorEdit: {},
    };
  },
  created() {
    this.GetData();
  },
  methods: {
    GetData() {
      api.get("/api/tenant/GetInfo").then((res) => {
        this.info = res.data;
      });
    },
    ShowSettings(cn) {
      this.currentConnectorEdit = cn;
      this.showConnectorSettings = true;
    },
    SelectConnector(provider, connectortype) {
      var cn = this.currentConnectorEdit;
      if (cn && cn.connectortype && cn.provider) {
        if (
          cn.connectortype.toLowerCase() == connectortype.toLowerCase() &&
          cn.provider.toLowerCase() == provider.toLowerCase()
        )
          return true;
      }

      return false;
    },
  },
};
</script>

<style>
</style>